import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DcNonView_Report = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState("Non-Returnable");

  const branch = localStorage.getItem("branch");

  const canView  = hasPermission("DC Non-Returnable Report", "view");
  useEffect(() => {
    fetchData();
  }, [selectedType]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/dcNonReturnList_report", {
        params: { type: selectedType, branch: branch },
      });

      const list = response.data.purchaseOrderList || [];
      console.log("API Response:", list);
      setData(list);
      setFilteredData(list);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
      Swal.fire("Error", "Failed to fetch report data.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter(
      (item) =>
        String(item.dcdetail_number || "").toLowerCase().includes(term) ||
        String(item.dcheader_supplierName || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // Group data by DC number
  const groupByDC = (list) => {
    const grouped = {};
    list.forEach((item) => {
      if (!grouped[item.dcdetail_number]) {
        grouped[item.dcdetail_number] = [];
      }
      grouped[item.dcdetail_number].push(item);
    });
    return grouped;
  };

  const groupedData = groupByDC(filteredData);
  const dcNumbers = Object.keys(groupedData);

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDCNumbers = dcNumbers.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(dcNumbers.length / itemsPerPage);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">D.C Non Returnable - Report</h2>
          <Time />
        </section>

        {/* Type Selection */}
        <div className="month-year-container">
          <p className="title">Type</p>
          <div className="select-container">
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="custom-select"
              style={{ width: "170px" }}
            >
              <option value="Non-Returnable">Non-Returnable</option>
              <option value="Purchase-Rejection">Purchase-Rejection</option>
            </select>
          </div>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search:</p>
          <input
            type="text"
            placeholder="Search by DC No or Supplier"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>D.C No</th>
                <th>Date</th>
                <th>Party Name</th>
                <th>CSP/Ref.</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>UOM</th>
                <th>Ref No.</th>
                <th>D.C Qty</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentDCNumbers.length > 0 ? (
                currentDCNumbers.map((dcNo, dcIndex) => {
                  const items = groupedData[dcNo];
                  const firstItem = items[0];
                  return items.map((item, index) => (
                    <tr key={`${dcNo}-${index}`}>
                      {/* Only show DC info in the first row */}
                      {index === 0 ? (
                        <>
                          <td rowSpan={items.length}>
                            {indexOfFirstItem + dcIndex + 1}
                          </td>
                          <td rowSpan={items.length}>{item.dcdetail_number}</td>
                          <td rowSpan={items.length}>
                            {item.dcheader_date
                              ? new Date(item.dcheader_date).toLocaleDateString()
                              : ""}
                          </td>
                          <td rowSpan={items.length}>
                            {item.dcheader_suppliercode} -{" "}
                            {item.dcheader_supplierName}
                          </td>
                        </>
                      ) : null}
                      <td>{item.DcDetail_referrence}</td>
                      <td>{item.dcdetail_itemcode}</td>
                      <td>{item.dcdetail_ItemName}</td>
                      <td>{item.dcdetail_uom}</td>
                      <td>{item.dcheader_yourReferenceNumber}</td>
                      <td>{item.dcdetail_quantity}</td>
                    </tr>
                  ));
                })
              ) : (
                <tr>
                  <td colSpan="10">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={currentPage === index + 1 ? "active" : ""}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default DcNonView_Report;
